import type { PropsWithChildren } from 'react';
import { useLayoutEffect } from 'react';

import { useAdmin } from '@/_providers/administration';
import { useIsMobile } from '@/_shared';
import type { RouteListItem } from '@/types';

import { SecondaryNavbar } from './navbar';

const SECONDARY_DRAWER_BREAKPOINT = 768;

export function SecondaryPageLayoutLoading({
  children,
  ...props
}: PropsWithChildren<{ subNavLinks: RouteListItem[] }>) {
  const widthCtrl = useAdmin();
  const isCompact = useIsMobile(SECONDARY_DRAWER_BREAKPOINT);

  useLayoutEffect(() => {
    widthCtrl[1]((s) => ({ ...s, isFullWidth: false, isDoubleColumn: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <article className="flex flex-1">
      <aside>
        {!isCompact && (
          <nav className="sticky top-16 w-28">
            <SecondaryNavbar {...props} isLoading />
          </nav>
        )}
      </aside>
      <section className="flex-1">{children}</section>
    </article>
  );
}
